import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function AdventureLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer" role="menu">
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/categories/adventure" id="categories-adventure" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.adventure" defaultMessage="Adventure" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/adventure-rpg" id="categories-adventurerpg" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.adventure-rpg" defaultMessage="Adventure RPG" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/casual" id="categories-casual" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.casual" defaultMessage="Casual" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/hidden-object" id="categories-hiddenobject" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.hidden-object" defaultMessage="Hidden Object" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/metroidvania" id="categories-metroidvania" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.metroidvania" defaultMessage="Metroidvania" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/puzzle" id="categories-puzzle" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.puzzle" defaultMessage="Puzzle" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/visual-novel" id="categories-visualnovel" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="adventure-links.link.visual-novel" defaultMessage="Visual Novel" />
        </TrackingLink>
      </li>
    </ul>
  );
}

AdventureLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

AdventureLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
